import {
  type IBaseLayoutOptions,
  type IWidgetOption,
  type WidgetType,
} from '../../../Widget.ts';
import { type IInputWidget } from '../IInputWidget.ts';

export enum MultiSelectKind {
  Checkbox = 'checkbox',
  Select = 'select',
}

export interface IMultiSelectWidgetLayout extends IBaseLayoutOptions {
  /** Solo per Checkbox/radio */
  direction?: 'horizontal' | 'vertical';
  separator?: 'label' | 'text';
  /** Nascondi etichetta */
  hideLabel?: boolean;
}

export interface IMultiSelectWidget extends IInputWidget {
  type: WidgetType.MultiSelect;
  options: IWidgetOption[];
  kind: MultiSelectKind;
  layout?: IMultiSelectWidgetLayout;
}
